import React from 'react';
import { inputArrow } from 'static/icons/resizable';
import { IconPadded } from 'view/atoms/IconPadded';

export const CustomDropdownIndicator = () => {
  return (
    <IconPadded
      className='Select__dropdown-indicator'
      src={inputArrow}
      alt='location'
      customStyles={{
        desktop: { padding: '6px' },
        mobile: { padding: '5px' },
      }}
    />
  );
};
